import SideModal from "components/SideModal";
import { useToast } from "contexts/ToastContext";
import { ChangeEvent, useState } from "react";
import {
  editAppeal2,
  editComplaint,
} from "services/prosecutorDecipilineService";
import { Appeal, Complaints } from "types";
import { LoadingIcon } from "utils/constant";
import "../styles/AddVictimModal.css";
import { COMPLIANT_STATUS } from "utils/constantValues";

interface ModalProps {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  appealData: Appeal;
  complaintData?: Complaints;
  onComplaintRefresh: any;
}

export default function RejectAppealModal({
  isOpen,
  setIsOpen,
  appealData,
  complaintData,
  onComplaintRefresh,
}: ModalProps) {
  const { showToast } = useToast();
  const [loading, setLoading] = useState(false);

  const [formState, setFormState] = useState({
    if_reject_comment: "",
  });

  const handleChange = (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;
    setFormState((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (!appealData?.id) {
      showToast("Complaint not found!", "error");
      return;
    }
    setLoading(true);

    try {
      await editAppeal2(
        {
          if_reject_comment: formState?.if_reject_comment,
        },
        appealData?.id
      );

      if (complaintData) {
        await editComplaint({
          ...complaintData,
          status: COMPLIANT_STATUS.APPEAL_REJECTED_FOR_INSPECTION,
        });
      }

      onComplaintRefresh();
      setIsOpen(false);
      showToast("Successfully Created", "success");
      setFormState({
        if_reject_comment: "",
      });
    } catch (err: any) {
      console.error("Submission error:", err);
      showToast("Submission error", "error");
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <SideModal
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      title={"Reject Appeal Claim"}
    >
      <form onSubmit={handleSubmit} className="victim-form">
        <section className="victim-section">
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Response
            </label>
            <textarea
              required
              rows={4}
              className="w-full border bg-gray-100 rounded-md p-2 text-sm"
              name="if_reject_comment"
              placeholder="Response here ..."
              value={formState.if_reject_comment}
              onChange={handleChange}
            />
          </div>
        </section>

        <button
          type="submit"
          className="bg-black w-full text-white px-6 py-2 rounded-md hover:bg-gray-800"
          disabled={loading}
        >
          {loading ? (
            <div className="flex items-center justify-center">
              {LoadingIcon}
              Submitting...
            </div>
          ) : (
            "Reject Appeal Claim"
          )}
        </button>
      </form>
    </SideModal>
  );
}
